<template>
  <v-btn
    class="btn-dark"
    :style="{ width: width }"
    @click="$emit('click')"
    :disabled="disabled"
    depressed
    color="secondary"
  >
    <slot />
  </v-btn>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  name: "ButtonPrimary",
  props: {
    title: String,
    width: String,
    disabled: Boolean,
    tooltip: String,
  },
});
</script>

<style lang="scss" scoped>
@import "@/scss/theme.scss";
@import "@/scss/custom_variables.scss";

.btn-dark {
  font-family: Work Sans, sans-serif;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: -0.04px;
  width: $btn-width;
  height: $btn-height !important;
  border-radius: $border-radius-small;
  color: var(--v-primary-base) !important;

  &.v-btn--disabled.v-btn--has-bg {
    background-color: var(--v-background-medium-base) !important;
  }

  ::v-deep {
    .v-icon {
      color: var(--v-primary-base) !important;
    }
  }
}
</style>
